import PasswordRules from './PasswordRules';
import { isPasswordValid } from './password';
import PhoneNumberInput from '../inputs/PhoneNumberInput';
import { isPhoneNumberValid } from '../inputs/phoneNumber';

export default function AcceptInvitationForm({
    loading,
    verifyError,
    details,
    email,
    existingPassword,
    name,
    title,
    mobile,
    defaultCountry,
    password,
    error,
    onChange,
    onAcceptExisting,
    onRegister,
    onBack
}) {
    if (loading) {
        return (
            <div className="auth-loading">
                <div className="loader"></div>
                <p>Verifying invitation...</p>
            </div>
        );
    }

    if (verifyError) {
        return (
            <>
                <h1>Invitation unavailable</h1>
                <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{verifyError}</div>
                <button type="button" className="btn-secondary auth-submit" onClick={onBack}>Back to sign in</button>
            </>
        );
    }

    if (!details) return null;

    return (
        <>
            <h1>Accept invitation</h1>
            <p className="auth-subtitle">
                You have been invited to join <strong>{details.organizationName}</strong>.
            </p>

            {details.userExists ? (
                <form onSubmit={onAcceptExisting} className="auth-form">
                    <input type="email" className="input-field" value={email} disabled />
                    <input type="password" className="input-field" placeholder="Existing account password" value={existingPassword} onChange={e => onChange('existingPassword', e.target.value)} required autoFocus />
                    {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}
                    <button type="submit" className="btn-primary auth-submit">Accept &amp; sign in</button>
                </form>
            ) : (
                <form onSubmit={onRegister} className="auth-form">
                    <input type="email" className="input-field" value={email} disabled />
                    <input type="text" className="input-field" placeholder="Full name" value={name} onChange={e => onChange('name', e.target.value)} required autoFocus />
                    <input type="text" className="input-field" placeholder="Job title" value={title} onChange={e => onChange('title', e.target.value)} required />
                    <PhoneNumberInput
                        id="invite-phone"
                        value={mobile}
                        onChange={next => onChange('mobile', next)}
                        defaultCountry={defaultCountry}
                        placeholder="Mobile number"
                    />
                    <div>
                        <input type="password" className="input-field" placeholder="Create password" value={password} onChange={e => onChange('password', e.target.value)} required />
                        <PasswordRules password={password} />
                    </div>
                    {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}
                    <button type="submit" className="btn-primary auth-submit" disabled={!isPasswordValid(password) || !isPhoneNumberValid(mobile, { required: true })}>Register &amp; join</button>
                </form>
            )}

            <p className="auth-switch">
                <button type="button" className="auth-link muted" onClick={onBack}>Cancel &amp; back to sign in</button>
            </p>
        </>
    );
}
